import { isDate, isObjectType } from 'remeda';

import { camelize, snakize } from './stringUtils';

function deepLookup(data: TAny, formatFunc: (str: string) => string): TAny {
  if (Array.isArray(data)) {
    return data.map((datumn) => {
      return deepLookup(datumn, formatFunc);
    });
  }

  if (isDate(data) || !isObjectType(data)) {
    return data;
  }

  return Object.entries(data).reduce((result, [k, v]) => {
    let value;

    if (isDate(v) || !isObjectType(v)) {
      value = v;
    } else {
      value = deepLookup(v, formatFunc);
    }

    Object.assign(result, {
      [formatFunc(k)]: value,
    });

    return result;
  }, {});
}

export function deepCamelizeKeys(data: TAny): TAny {
  return deepLookup(data, camelize);
}

export function deepSnakeizeKeys(data: TAny): TAny {
  return deepLookup(data, snakize);
}

export function assign<T extends Record<TAny, TAny>>(
  source: T,
  target: Partial<T>,
): T {
  return Object.assign(source, target);
}

export function createNestedObject(
  path: string,
  value: TAny,
): Record<string, TAny> {
  const parts = path.split('.');
  const parent = parts[0];

  const nestedValue = parts.slice(1).reduceRight((value, key, index) => {
    return { [key]: index === parts.length - 2 ? value : { ...value } };
  }, value);

  return { [parent]: nestedValue };
}
